<router-outlet>
  
</router-outlet>

<app-footer [hideBarFlag]="true"></app-footer>
